var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "Automatic" }, [
    _c("div", { staticClass: "Automatic-content" }, [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "Collection-main" },
        [
          _c(
            "el-form",
            { staticClass: "Form-style" },
            [
              _c(
                "el-checkbox-group",
                {
                  on: { change: _vm.changCheck },
                  model: {
                    value: _vm.check,
                    callback: function ($$v) {
                      _vm.check = $$v
                    },
                    expression: "check",
                  },
                },
                [
                  _c("el-checkbox", { attrs: { label: 1 } }, [
                    _vm._v("若客户购买我提供的专属商品，自动确认订单。"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "Automatic-top" }, [
      _c("h1", [_vm._v("供应商自动接收信息设置")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }